import Icon from '../components/Icon.vue'

Icon.register({
  moon: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M283.2 512C362.2 512 434.3 476.1 482.1 417.2 489.1 408.5 481.4 395.8 470.5 397.9 346.3 421.5 232.2 326.3 232.2 200.9 232.2 128.7 270.9 62.3 333.7 26.5 343.4 21 341 6.3 330 4.3A258.2-258.2 0 0 1 283.2 0C141.9 0 27.2 114.5 27.2 256 27.2 397.3 141.7 512 283.2 512z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/moon.js
// module id = VtvX
// module chunks = 144